(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["grand-semainier-name"] && !Shopify.designMode) return;
  try {
    class GrandSemainierName extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.root = this.closest('.product-details') || document;
      this.input = this.querySelector('input');
      this.handleChange = this.handleChange.bind(this);
      this.root.addEventListener('change', this.handleChange);
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.root?.removeEventListener('change', this.handleChange);
    }

    handleChange() {
      requestAnimationFrame(() => this.updateVisibility());
    }

    updateVisibility() {
      const selectedControls = this.root.querySelectorAll(
        'input[type="radio"]:checked, select option:checked'
      );
      const selectedValues = Array.from(selectedControls).map((control) =>
        control.value.trim()
      );
      const nameSelected = selectedValues.includes('Avec prénom');
      const noNameSelected = selectedValues.includes('Sans prénom');
      const variantInput = this.form?.querySelector('input[name="id"]');
      const variantMatches = variantInput?.value === this.dataset.nameVariantId;
      const isNameVariant = nameSelected || (!noNameSelected && variantMatches);

      this.hidden = !isNameVariant;
      this.input.required = isNameVariant;
      this.input.setAttribute('aria-required', isNameVariant ? 'true' : 'false');

      if (noNameSelected) this.input.value = '';
    }
  }

  if (!customElements.get('grand-semainier-name')) {
    customElements.define('grand-semainier-name', GrandSemainierName);
  }
  } catch(e) { console.error(e); }
})();

})();
